import React from 'react'
import { Link } from 'react-router-dom';
import homeIcon from './../../../assets/home.png'
import propertyIcon from './../../../assets/property.png'
import duesIcon from './../../../assets/dues.png'
import residentIcon from './../../../assets/residents.png'
import guestIcon from './../../../assets/guest.png'
// import complaintsIcon from './../../../assets/complaints.png'
// import filesIcon from './../../../assets/dues.png'
import communicationIcon from './../../../assets/complaints.png'
// import reportsIcon from './../../../assets/reports.png'
import bankIntegrationIcon from './../../../assets/property.png'
import settingsIcon from './../../../assets/settings.png'
import securityIcon from './../../../assets/security.png'
// import paymentIcon from './../../../assets/payment.png'
import logoutIcon from './../../../assets/logout.png'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuth } from '../../../context/AuthContext';
import { Dialog,Pane } from 'evergreen-ui';

import {

    SidebarListItem,
    SidebarListItemRow,
    SidebarListItemIconContainer,
    Sidebar,
    FieldBtn
 } from './SidebarWidget.style';
import Cookies from 'js-cookie';
import {Redirect} from "react-router-dom"

function SidebarWidget() {
const accesTokenValue = Cookies.get('userAccessToken');
const managerType = Cookies.get('managerType');
const history = useHistory()
const addNewEstateCTA= (e)=>{
    e.preventDefault()
    history.push("/addAssets");
}


  return (
    <div
    className='hide-on-small-only hide-on-med-only'
    style={{
        marginLeft:"-10px"
    }}>
        { (accesTokenValue === undefined || accesTokenValue.length <=0) &&
            <Redirect to="/" />
        }
        <Sidebar>
        <br/>      
         <ul class=" " style={{
                border:"none !important"
            }}>
                {/* <Link to='/dashboard'>
                    <FieldBtn onClick={addNewEstateCTA} class="waves-effect waves-light btn-flat ">
                        <i class="material-icons left">add</i>
                        Add New Estate
                    </FieldBtn>
                </Link> */}
                {managerType!=="sub" &&<Link to='/addAssets'>
                    <FieldBtn onClick={addNewEstateCTA} class="waves-effect waves-light btn-flat ">
                            <i class="material-icons left">add</i>
                            Add New Assets
                        </FieldBtn>
                    </Link>
                }
                <Link to='/dashboard'>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={homeIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Home
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                
                <Link to='/property'>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={propertyIcon} width="20px" alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Units
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>

                <Link to='/dues'>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={duesIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Dues
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to="/communication">
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={communicationIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Communication
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to="/complaint">
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={duesIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Complaints
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                {managerType !=="sub" &&
                    <Link to='/banks'>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={bankIntegrationIcon} width="20px" alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Bank Integration
                        </SidebarListItem>
                    </SidebarListItemRow>
                    </Link>
                }
                
                <Link to='/resident'>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={residentIcon} alt='' width='20px' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Resident
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                
                <Link to='/owner'>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={propertyIcon} width="20px" alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Owner
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to="/security">
                <SidebarListItemRow>
                    <SidebarListItemIconContainer>
                        <center>
                            <img src={securityIcon} width={20} alt='' />
                        </center>
                    </SidebarListItemIconContainer>
                    <SidebarListItem >
                        Security Men
                    </SidebarListItem>
                </SidebarListItemRow>
                </Link>
                
                <Link to='/guests'>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={guestIcon} alt='' width="20px" />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Guests
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                
               
                
                {/* <Link to="/payment">
                <SidebarListItemRow>
                    <SidebarListItemIconContainer>
                        <center>
                            <img src={paymentIcon} width={20} alt='' />
                        </center>
                    </SidebarListItemIconContainer>
                    <SidebarListItem >
                        Payment
                    </SidebarListItem>
                </SidebarListItemRow>
                </Link> */}
                
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <Link to='/settings'>
                <SidebarListItemRow>
                    <SidebarListItemIconContainer>
                        <center>
                            <img src={settingsIcon} alt='' />
                        </center>
                    </SidebarListItemIconContainer>
                    <SidebarListItem >
                        Settings
                    </SidebarListItem>
                </SidebarListItemRow>
                </Link>
                
                <LogoutBtn/>
            
            </ul>
        </Sidebar>

    </div>
  )
}

export default SidebarWidget





function LogoutBtn() {
const [isShown, setIsShown] = React.useState(false)
const history = useHistory()
const {logout,refresh} = useAuth()
const clearAllCookies = () => {
    const cookies = Object.keys(Cookies.get());
    cookies.forEach(cookie => Cookies.remove(cookie));
  };

const logoutUser =(e)=>{
    // e.preventDefault()
    logout();
    clearAllCookies()
    Cookies.remove('userAccessToken');
    refresh();
    history.push(`/`);

}
  return (
    <Pane>
      <Dialog
        isShown={isShown}
        title="Log out"
        intent="danger"
        onCloseComplete={() => setIsShown(false)}
        confirmLabel="Logout"
        onConfirm={()=>{
            console.log("sad")
            logoutUser()
        }}
        shouldCloseOnOverlayClick={false}
      >
        Are you sure you want to Logout?
      </Dialog>

        {/* <Button >Show Dialog</Button> */}
        <SidebarListItemRow onClick={() => setIsShown(true)} >
            <SidebarListItemIconContainer>
                <center>
                    <img src={logoutIcon} alt='' />
                </center>
            </SidebarListItemIconContainer>
            <SidebarListItem >
                Logout
            </SidebarListItem>
        </SidebarListItemRow>
    </Pane>
  )
}
